var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Authenticator } from '@migros/authenticator';
import { WEB_API_URLS } from './environments';
const globalObject = typeof window !== 'undefined' ? window : global;
export class WebApiService {
    constructor(apiUri, additionalParams = {}) {
        this.apiUri = apiUri;
        this.additionalParams = additionalParams;
    }
    static getInstance() {
        if (globalObject.MigrosSharedWebApiService === undefined) {
            throw new Error('Not initialized');
        }
        return globalObject.MigrosSharedWebApiService;
    }
    static init(apiUri = WEB_API_URLS.production, additionalParams = {}) {
        if (globalObject.MigrosSharedWebApiService === undefined) {
            globalObject.MigrosSharedWebApiService = new WebApiService(apiUri, additionalParams);
        }
        else {
            console.warn('MigrosSharedWebApiService is already initialized. Make sure `WebApiService.init` is only called once.');
        }
    }
    setWebApiUri(uri) {
        this.apiUri = uri;
    }
    getWebApiUri() {
        return this.apiUri;
    }
    buildWidgetsUrl(path, params = {}) {
        return `widgets/${path}${path.includes('?') ? '&' : '?'}${new URLSearchParams(params).toString()}`;
    }
    fetch(path_1) {
        return __awaiter(this, arguments, void 0, function* (path, options = {}, withUserToken = false) {
            var _a;
            if (withUserToken) {
                const token = yield Authenticator.getInstance().getToken();
                if (token) {
                    options.headers = Object.assign(Object.assign({}, ((_a = options.headers) !== null && _a !== void 0 ? _a : {})), { Authorization: `Bearer ${token}` });
                }
            }
            const url = new URL(`${this.apiUri}/${path}`);
            Object.keys(this.additionalParams).forEach((key) => url.searchParams.append(key, this.additionalParams[key]));
            return fetch(url.toString(), options);
        });
    }
    sendBeacon(path, data) {
        const url = new URL(`${this.apiUri}/${path}`);
        Object.keys(this.additionalParams).forEach((key) => url.searchParams.append(key, this.additionalParams[key]));
        return typeof window !== 'undefined' && navigator.sendBeacon ? navigator.sendBeacon(url.toString(), data) : false;
    }
}
